import { Container } from '@material-ui/core';
import React, { useContext } from 'react';
import codings from '../../assets/lottie/coding.json';
import { ThemeContext } from '../../contexts/ThemeContext';
import './Github.css';
// import GitHubCalendar from 'react-github-calendar';




function Github() {

    const { theme } = useContext(ThemeContext);

    return (
        <div style={{ backgroundColor: theme.secondary }}>
            <Container className="about" id="about">
                <div className="line-styling">
                    <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
                    <div className="style-circle" style={{ backgroundColor: theme.primary }}></div>
                    <div className="style-line" style={{ backgroundColor: theme.primary }}></div>
                </div>
                <div className="git-body">
                    <div className="git-description">
                        <h2 style={{ color: theme.primary }}>Days I Code</h2> 
                        {/* <p>&nbsp;<img align="center" src="https://github-readme-stats.vercel.app/api?username=kalashthakur&show_icons=true&locale=en&theme=radical" alt="kalashthakur" /></p> */}
                        <p>&nbsp;<img align="center" src="https://github-readme-stats.vercel.app/api?username=kalashthakur&show_icons=true&locale=en&theme=radical" alt="kalashthakur" /></p>
                        <br /> <br />
                        <p><img align="center" src="https://github-readme-streak-stats.herokuapp.com/?user=kalashthakur&theme=radical" alt="kalashthakur" /></p>
                        <br /> <br />


                        {/* <GitHubCalendar username="KalashThakur" /> */}
                       
           
                    </div>
                   {/* < GitHubCalendar username='AASHSHISHKUMAR321' /> */}
                    
                </div>
            </Container>
           

           
        </div>
    )
}

export default Github
